import { MediaAdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { adminJobsKeys } from 'app/queries/adminJobs/adminJobsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof adminJobsKeys.signedMediaUrl>>;

export const createFetchSignedMediaUrlQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ jobId, file }], signal }: TParams) =>
    call(() => cancelOnSignal(MediaAdminService.adminGetSignedUrl({ jobId, file, forceCache: Date.now() }), signal));
